export class BaseUser {
  constructor(
    protected id: number,
    protected username?: string,
    private firstName?: string,
    private lastName?: string,
  ) {}

  public getId(): number {
    return this.id;
  }

  public getUsername(): string {
    return this.username;
  }

  public getFirstName(): string {
    return this.firstName;
  }

  public getLastName(): string {
    return this.lastName;
  }
}
